(function () {
  'use strict';

  angular.module('app').component('bookingHistory', bookingHistory());

  function bookingHistory() {
    return {
      bindings: {
        bookingHistories: '=',
        users: '<',
      },
      controller: BookingHistoryComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/components/booking-history/booking-history.component.html',
    };
  }

  BookingHistoryComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'moment'];

  function BookingHistoryComponent(config, UtilService, moment) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY_24;

    vm.$onInit = function () {
      setBookingHistories(vm.bookingHistories);
    };

    // Attach user name to booking histories
    function setBookingHistories(bookingHistories) {
      vm.histories = [];

      if (bookingHistories) {
        var last = bookingHistories.length - 1;
        var inicial = moment(bookingHistories[0].created_at);
        var final = moment(bookingHistories[last].created_at);

        while (inicial.startOf('day') <= final.startOf('day')) {
          var objs = [];

          bookingHistories.forEach(function (booking_history) {
            var date = moment(booking_history.created_at);

            if (date.format('YYYY-MM-DD') === inicial.format('YYYY-MM-DD')) {
              booking_history.user = vm.UtilService.findItemInArray(
                vm.users,
                'id',
                booking_history.user_id
              );

              objs.push(booking_history);
            }
          });

          if (objs.length) {
            vm.histories.push({
              date: inicial.format('YYYY-MM-DD'),
              history: objs,
            });
          }

          inicial.add(1, 'day');
        }
      }
    }
  }
})();
